import { useEffect, useMemo, useState } from 'react';
import DataFlowService from '../../../services/DataFlow.service';
import { useTranslation } from 'react-i18next';

export function useDataSubject(collectData) {
    const [dataSubject, setDataSubject] = useState([]);
    const { i18n } = useTranslation();

    useEffect(() => {
        const getDataSubject = async () => {
            const { data } = await DataFlowService.getDataSubject();
            if (data.resultData) {
                setDataSubject(data.resultData);
            }
        };
        getDataSubject();
    }, []);

    const getDataSubjectName = (id) => {
        if (id && dataSubject?.length > 0) {
            const result = dataSubject.filter(
                (data) => data.dataSubjectId === id
            );
            return i18n.language === 'en'
                ? result[0]?.nameEn
                : result[0]?.nameTh;
        }
    };

    return collectData?.dataSubject.length > 0
        ? collectData?.dataSubject.map((item) => getDataSubjectName(item))
        : '-';
}

export function useDepartment(collectData) {
    const [department, setDepartment] = useState([]);
    const { i18n } = useTranslation();

    useEffect(() => {
        const getDepartment = async () => {
            const { data } = await DataFlowService.getAllDepartmentList();
            if (data.resultData) {
                setDepartment(data.resultData);
            }
        };
        getDepartment();
    }, []);

    const getDepartmentName = (id) => {
        if (id && department?.length > 0) {
            const result = department.filter(
                (data) => data.departmentId === id
            );
            return i18n.language === 'en'
                ? result[0]?.nameEn
                : result[0]?.nameTh;
        }
    };

    return collectData?.organizeDataCollection?.length > 0
        ? collectData?.organizeDataCollection?.map((item) =>
              getDepartmentName(item)
          )
        : '-';
}

export function useStorageLocation(collectDataDestruction) {
    const [storageLocation, setStorageLocation] = useState([]);
    const { i18n } = useTranslation();

    useEffect(() => {
        const getMasterStorageLocation = async () => {
            const { data } = await DataFlowService.getMasterStorageLocation();
            if (data?.resultData) {
                const storageLocation = data?.resultData;
                setStorageLocation(storageLocation);
            }
        };
        getMasterStorageLocation();
    }, []);

    const getMasterStorageLocationName = (id) => {
        if (id && storageLocation?.length > 0) {
            const result = storageLocation.filter(
                (data) => data.statusId === id
            );
            if (result?.length > 0) {
                return i18n.language === 'en'
                    ? result[0]?.nameEn
                    : result[0]?.nameTh;
            } else {
                return id;
            }
        }
    };

    const storageLocationAddOn = useMemo(
        () =>
            collectDataDestruction?.storageLocationAddOn.map(
                (item) => item?.tstorageLocationAddOnName
            ) || [],
        [collectDataDestruction?.storageLocationAddOn]
    );

    return {
        storageLocation: collectDataDestruction?.storageLocation.map((item) =>
            getMasterStorageLocationName(item)
        ),
        storageLocationAddOn,
    };
}
